export default "__VITE_ASSET__YSRnZxNJ__"